import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatBody1Directive } from './mat-body-1.directive';
import { MatBody2Directive } from './mat-body-2.directive';
import { MatCaptionDirective } from './mat-caption.directive';
import { MatDisplay1Directive } from './mat-display-1.directive';
import { MatDisplay2Directive } from './mat-display-2.directive';
import { MatDisplay3Directive } from './mat-display-3.directive';
import { MatHeadLineDirective } from './mat-headline.directive';
import { MatSubHeading1Directive } from './mat-subheading-1.directive';
import { MatSubHeading2Directive } from './mat-subheading-2.directive';
import { MatTitleDirective } from './mat-title.directive';

@NgModule({
    declarations: [
        MatBody1Directive,
        MatBody2Directive,
        MatCaptionDirective,
        MatDisplay1Directive,
        MatDisplay2Directive,
        MatDisplay3Directive,
        MatHeadLineDirective,
        MatSubHeading1Directive,
        MatSubHeading2Directive,
        MatTitleDirective
    ],
    imports: [ CommonModule ],
    exports: [
        MatBody1Directive,
        MatBody2Directive,
        MatCaptionDirective,
        MatDisplay1Directive,
        MatDisplay2Directive,
        MatDisplay3Directive,
        MatHeadLineDirective,
        MatSubHeading1Directive,
        MatSubHeading2Directive,
        MatTitleDirective
    ],
    providers: [],
})
export class EvkMatTypographyModule {}
